import styled from "styled-components";

export const AllNftWrapper = styled.div`
  background: white !important;
  .filterAllInput {
    height: 32px;
    border-radius: 10px;
    margin-top: 2rem;
    border: 1px solid #7f8c8d;
    width: 100%;
    padding: 0.5rem;

    ::placeholder {
      padding-left: 1rem !important;
    }
  }
`;

export const MinMaxMain = styled.div`
  .minMaxMain {
    display: flex;
    gap: 0.7rem;
    flex: 1;
    /* flex-wrap: wrap; */
    input {
      height: 32px;
      width: 50%;
      border-radius: 10px;
      border: 1px solid #7f8c8d;
      padding: 0.5rem;
      ::placeholder {
        padding-left: 1rem !important;
      }
    }
  }
`;
